import { render, staticRenderFns } from "./NotificationModalPopout.vue?vue&type=template&id=67e9bda1&scoped=true"
import script from "./NotificationModalPopout.vue?vue&type=script&lang=ts"
export * from "./NotificationModalPopout.vue?vue&type=script&lang=ts"
import style0 from "./NotificationModalPopout.vue?vue&type=style&index=0&id=67e9bda1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9bda1",
  null
  
)

export default component.exports